// src/js/config/ui/loadAndDisplayConfiguration.js
import { DOMElements } from '../dom.js';
import { showMessage, hideMessage } from './showMessage.js';
import { updateOrderSummaryDisplay } from './orderSummaryDisplay.js';
import { loadConfigData } from '../configLoader.js';
import { setLoadedPackageConfig } from '../orderState.js';
import { renderConfigurationTable } from './renderConfigurationTable.js';

export async function loadAndDisplayConfiguration(sourceType, valueOrFile) {
    const { output, selectedConfigDisplayNotValid } = DOMElements;
    hideMessage();

    // Återställ båda containrarna
    if (output) output.classList.remove('is-visible');
    if (selectedConfigDisplayNotValid) selectedConfigDisplayNotValid.classList.remove('is-visible');

    if (sourceType === 'select' && (!valueOrFile || valueOrFile === "default")) {
        setLoadedPackageConfig(null);
        updateOrderSummaryDisplay(null);
        renderConfigurationTable(null);
        return;
    }

    const result = await loadConfigData(sourceType, valueOrFile);

    if (result.success) {
        // FALL 1: GILTIG KONFIGURATION
        const { configData } = result.data;
        if (output) output.classList.add('is-visible');

        setLoadedPackageConfig(configData);
        updateOrderSummaryDisplay(configData);
        renderConfigurationTable(configData);
    } else {
        // FALL 2: OGILTIG KONFIGURATION
        if (selectedConfigDisplayNotValid) selectedConfigDisplayNotValid.classList.add('is-visible');

        setLoadedPackageConfig(null);
        updateOrderSummaryDisplay(null);
        renderConfigurationTable(null);

        showMessage(result.message, result.isWarning ? 'info' : 'error');
    }
}